import { isSlotSelected } from '../../../utils/dateTime'
import { EmptyState } from '../../shared/EmptyState'
import { LoadingSpinner } from '../../shared/LoadingSpinner'
import type { AvailableSlot } from '../../../types/bookings'
import styles from './TimeSlotGrid.module.scss'

interface TimeSlotGridProps {
  hasSelectedDate: boolean
  slots: AvailableSlot[]
  isLoading: boolean
  selectedSlot: AvailableSlot | null
  onSelectSlot: (slot: AvailableSlot) => void
}

export function TimeSlotGrid({
  hasSelectedDate,
  slots,
  isLoading,
  selectedSlot,
  onSelectSlot,
}: TimeSlotGridProps) {
  if (!hasSelectedDate) {
    return (
      <EmptyState
        title="Choose a date first"
        description="Available appointment times will appear here once a day is selected."
      />
    )
  }

  if (isLoading) {
    return <LoadingSpinner message="Checking live availability..." />
  }

  if (!slots.length) {
    return (
      <EmptyState
        title="No slots available"
        description="Try another date or change the selected staff preference."
      />
    )
  }

  return (
    <div className={styles.grid}>
      {slots.map((slot) => (
        <button
          key={`${slot.staffId}-${slot.startDateTime.toISOString()}`}
          type="button"
          className={`${styles.slot} ${isSlotSelected(slot, selectedSlot) ? styles.slotSelected : ''}`}
          onClick={() => onSelectSlot(slot)}
        >
          {slot.label}
        </button>
      ))}
    </div>
  )
}
